<template>
  <div class="row d-flex justify-content-center">
    <div class="col-9">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="showInfoTag(info)"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <td
              :style="{
                wordBreak: 'auto-phrase',
                textAlign: 'justify',
              }"
              v-else-if="
                typeof info.visibility === 'undefined' ||
                Boolean(info.visibility)
              "
            >
              <h6 class="mb-1">
                <strong>{{ info.label }}:</strong>
              </h6>
              <span v-if="validateIsset(info.value)" class="mt-2">
                {{ info.value }}
              </span>
              <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                $t('common_words.no_assignment')
              }}</el-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';

export default {
  name: 'step-confirm',
  components: {
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  data() {
    return {
      renderComponent: true,
    };
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.code'),
          value: this.infoData.code,
        },
        {
          label: i18n.t('common_words.name'),
          value: this.infoData.name,
        },
        {
          label: i18n.t('sowing.sowing_method'),
          value: this.infoData.type,
        },
        {
          label: i18n.t('sowing.sowing_type'),
          value: this.infoData.sowing_type,
        },
        {
          label: i18n.t('sowing.seed_type'),
          value: this.infoData.seedTypeName,
        },
        {
          label: i18n.t('common_words.distance'),
          value: this.infoData.distance,
        },
        {
          label: i18n.t('climate.temperature'),
          value: this.infoData.temperature,
        },
        {
          label: i18n.t('common_words.description'),
          value: this.infoData.description,
        },
        {
          label: i18n.t('common_words.associated_companies'),
          value: this.infoData.businesses_names,
          fieldTag: 'option',
        },
      ];
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    showInfoTag(info) {
      return (
        (typeof info.visibility === 'undefined' || Boolean(info.visibility)) &&
        this.validateIsset(info.value) &&
        Array.isArray(info.value) &&
        info.type !== 'contacts'
      );
    },
  },
};
</script>
